import { useLocation, matchPath } from "react-router-dom";
import useUserAgent from "./useUserAgent.js";
import { useMemo } from "react";
import routeMap from "../app/routes.js";
import useGlobalContext from "./useGlobalContext.js";
export default function useRouteName() {
    const location = useLocation();
    const { isMobile, isWebview } = useUserAgent();
    const { isPaymentCollectionPage, isNewFlightDetailsPage, isNewFlightDetailsDesktopPage } = useGlobalContext();
    return useMemo(() => {
        for (const route of routeMap({
            isMobile,
            isNewFlightDetailsPage: !!isNewFlightDetailsPage,
            isNewFlightDetailsDesktopPage: !!isNewFlightDetailsDesktopPage,
            isPaymentCollectionPage,
            isWebview
        })) {
            if (matchPath(location.pathname, { path: route.path, exact: true })) {
                return route.name;
            }
        }
        throw new Error(`Current path <${location.pathname}> doesnt match a known route`);
    }, [
        location.pathname,
        isMobile,
        isPaymentCollectionPage,
        isWebview,
        isNewFlightDetailsPage,
        isNewFlightDetailsDesktopPage
    ]);
}
